import { render, staticRenderFns } from "./PrestationReservation.vue?vue&type=template&id=796fba32&scoped=true"
import script from "./PrestationReservation.vue?vue&type=script&lang=js"
export * from "./PrestationReservation.vue?vue&type=script&lang=js"
import style0 from "./PrestationReservation.vue?vue&type=style&index=0&id=796fba32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796fba32",
  null
  
)

export default component.exports